/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import { Box, Divider, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { css } from "aphrodite";
import {
  NEW_ENTRY_FIELDS,
  ORGANIZATION_STRUCTURE_FIELDS,
} from "../../../../../contants/formFields";
import { getOptions } from "../../../../../utils";
import AutoCompleteDropdown from "../../AutoCompleteDropdown/AutoCompleteDropdown";
import RemarksList from "../../RemarksList/RemarksList";
import Styles from "../ForwardModal/style";
// import InputField from "../../InputField/InputField";
import IntroductionFormApi from "../../../../../services/api/introductionForm";
import { debounce, isEmptyObj } from "../../../../../utils/helper";
import Button from "../../../Button";
import { CommonStyles } from "../../../Button/commonButtonStyle";
import Modal from "../../../Modal/Modal";
import InputField from "../../InputField/InputField";
import Style from "./AcceptModal.styles";

import {
  fetchRemarks,
  formValidation,
  getApi,
  getRemarkApiMethodAndName,
  getSeletedRowId,
  MODAL_TYPES,
} from "../utils";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../../contants";
import NewOrganization from "../ForwardModal/NewOrganization";

function AcceptForm({
  values,
  errors,
  setFieldValue,
  handleChange,
  selectedRow,
}) {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    if (response?.data) {
      const filteredState = response.data.find((s) => {
        return s.stateId === Number(selectedRow.state);
      });
      if (filteredState) {
        setFieldValue(NEW_ENTRY_FIELDS.STATE, filteredState.stateId);
        setCities(filteredState.cities);
        const filteredCity = filteredState.cities.find((c) => {
          return c.cityId === Number(selectedRow.city);
        });
        console.log("STATE:", selectedRow.filteredCity);

        if (filteredCity) {
          setFieldValue(NEW_ENTRY_FIELDS.CITY, filteredCity.cityId);
        }
      }
    }
  };

  useEffect(() => {
    getStates();
  }, []);
  return (
    <div style={{ display: "flex", flexDirection: "row", justifyItem: "left" }}>
      <div style={Styles.gridContainer}>
        <Grid
          style={{ ...Styles.gridItem, ...Styles.name }}
          className={css(Style.gridItemStyle)}
        >
          <InputField
            required
            label="Name"
            name={NEW_ENTRY_FIELDS.NAME}
            value={values[NEW_ENTRY_FIELDS.NAME]}
            error={errors[NEW_ENTRY_FIELDS.NAME]}
            onChange={handleChange}
            disabled
          />
        </Grid>
        <Grid
          style={{ ...Styles.inputField, ...Styles.gridItem }}
          className={css(Style.gridItemStyle)}
        >
          <InputField
            variant="outlined"
            required
            label="Address"
            value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
            name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
            error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
            onChange={handleChange}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <InputField
            variant="outlined"
            label="Pincode"
            name={NEW_ENTRY_FIELDS.PINCODE}
            value={values[NEW_ENTRY_FIELDS.PINCODE]}
            onChange={handleChange}
            error={errors[NEW_ENTRY_FIELDS.PINCODE]}
            inputProps={{
              maxLength: 6,
            }}
          />
        </Grid>
        {/* <div style={Styles.gridItem}>
          <InputField
            variant="outlined"
            label="Address Line 2"
            name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
            value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
            onChange={handleChange}
            error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
          />
        </div> */}
        <Grid style={Styles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.stateName}
            label="State"
            name={NEW_ENTRY_FIELDS.STATE}
            options={getOptions(states, "stateId")}
            error={errors[NEW_ENTRY_FIELDS.STATE]}
            value={values[NEW_ENTRY_FIELDS.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(NEW_ENTRY_FIELDS.STATE, "");
                setCities([]);
              } else {
                setFieldValue(NEW_ENTRY_FIELDS.STATE, selectedValue.value);
                setCities(selectedValue.cities);
              }
              setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
            }}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="City"
            name={NEW_ENTRY_FIELDS.CITY}
            options={getOptions(cities, "cityId")}
            error={errors[NEW_ENTRY_FIELDS.CITY]}
            value={values[NEW_ENTRY_FIELDS.CITY]}
            disabled={!values[NEW_ENTRY_FIELDS.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
              } else {
                setFieldValue(NEW_ENTRY_FIELDS.CITY, selectedValue.value);
              }
            }}
          />
        </Grid>
        {/* <div style={Styles.gridItem} /> */}
        <Grid style={Styles.gridItem}>
          <InputField
            variant="outlined"
            required
            label="Contact Number"
            value={values[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
            name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
            onChange={handleChange}
            error={errors[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
            inputProps={{
              maxLength: 10,
            }}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <InputField
            variant="outlined"
            label="Email Address"
            name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
            value={values[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
            error={errors[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
            onChange={handleChange}
          />
        </Grid>
        {values[NEW_ENTRY_FIELDS.DIVISION] === 52 ||
        values[NEW_ENTRY_FIELDS.DIVISION] === 53 ? (
          <>
            <Grid style={Styles.gridItem}>
              <InputField
                required
                label="Parent's Contact Number"
                name={NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER}
                onChange={handleChange}
                error={errors[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
                value={values[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
                inputProps={{
                  maxLength: 10,
                }}
              />
            </Grid>
            <Grid style={Styles.gridItem}>
              <InputField
                label="Parent's Email Address"
                name={NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS}
                error={errors[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
                value={values[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
                onChange={handleChange}
              />
            </Grid>
          </>
        ) : null}
        <Grid style={Styles.gridItem}>
          <InputField
            required
            label="Introducer's Name"
            name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
            onChange={handleChange}
            value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]}
            // disabled
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <InputField
            label="Introducer's Contact Number"
            required
            name={NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
            value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
            onChange={handleChange}
            inputProps={{
              maxLength: 10,
            }}
            // disabled
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <InputField
            label="Introducer's Email Address"
            name={NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL}
            value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]}
            onChange={handleChange}
            // disabled
          />
        </Grid>
      </div>
    </div>
  );
}

function AcceptModal({
  open,
  onClose,
  selectedRow,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
  refreshTransferList,
}) {
  const [remarks, setRemarks] = useState([]);
  const [remark, setRemark] = useState("");
  const toast = useContext(ToastAlertContext);

  const onSubmit = async (payload) => {
    try {
      const error = formValidation(payload, remark, true);
      if (error) throw new Error(error);

      // get Accept api, name and payload
      const { api, apiName, apiPayload } = getApi({
        cameFromMemberTransfer,
        cameFromFriendTransfer,
        selectedRow,
        modalType: MODAL_TYPES.ACCEPT,
        body: payload,
      });
      // calling Accept api
      await api[apiName](apiPayload);
      const prepareRemarkPayload = (success = false) => ({
        data: {
          message: remark,
          event: success ? "success" : "rejection",
        },
      });

      // Accept api success, now hit remark api if remark is present
      if (remark.length) {
        const remarkBody = prepareRemarkPayload(remark, true);
        const {
          api: remarkAPi,
          apiName: remarkApiName,
          apiPayload: remarkPayload,
        } = getRemarkApiMethodAndName({
          cameFromMemberTransfer,
          cameFromFriendTransfer,
          selectedRow,
          body: remarkBody,
        });
        // calling remark api
        await remarkAPi[remarkApiName](remarkPayload);
      }
      toast.show("Accepted Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        refreshTransferList();
      }, 2000);
    } catch (err) {
      Sentry.captureException(err);
      toast.show(
        err.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  useEffect(() => {
    if (!isEmptyObj(selectedRow)) {
      const id = getSeletedRowId(selectedRow);
      fetchRemarks({
        cameFromFriendTransfer,
        cameFromMemberTransfer,
        id,
        setRemarks,
      });
    }
  }, [cameFromFriendTransfer, cameFromMemberTransfer, selectedRow]);

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Modal
      open={open}
      onClose={onClose}
      // customStyle={{ height: "auto", overflowY: "auto" }}
      customStyle={{
        maxHeight: "98%",
        overflowY: "auto",
        maxWidth: isMobile ? "90%" : "100%",
      }}
    >
      <Grid container style={{ paddingTop: "10px 10px 0px 0px" }}>
        <Formik
          enableReinitialize
          initialValues={{
            [ORGANIZATION_STRUCTURE_FIELDS.REGION]:
              selectedRow?.targetOrganizationStructure?.targetOrgRegionId,
            [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]:
              selectedRow?.targetOrganizationStructure?.targetOrgClusterId,
            [ORGANIZATION_STRUCTURE_FIELDS.ZONE]:
              selectedRow?.targetOrganizationStructure?.targetOrgZoneId,
            [ORGANIZATION_STRUCTURE_FIELDS.AREA]:
              selectedRow?.targetOrganizationStructure?.targetOrgAreaId,
            [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]:
              selectedRow?.targetOrganizationStructure?.targetOrgDistrictId,
            [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]:
              selectedRow?.targetOrganizationStructure?.targetOrgChapterId,
            [NEW_ENTRY_FIELDS.ADDRESS_LINE_1]: selectedRow?.addressLine1,
            [NEW_ENTRY_FIELDS.ADDRESS_LINE_2]: selectedRow?.addressLine2,
            [NEW_ENTRY_FIELDS.CITY]: Number(selectedRow?.city),
            [NEW_ENTRY_FIELDS.STATE]: Number(selectedRow?.state),
            [NEW_ENTRY_FIELDS.PINCODE]: selectedRow?.pincode,
            [NEW_ENTRY_FIELDS.CONTACT_NUMBER]: selectedRow?.mobileNumber,
            [NEW_ENTRY_FIELDS.EMAIL_ADDRESS]: selectedRow?.emailId,
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]:
              selectedRow?.introducedByName,
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]:
              selectedRow?.introducedByMobileNumber,
            [NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]:
              selectedRow?.introducedByEmail,
            [NEW_ENTRY_FIELDS.NAME]: selectedRow?.fullName,
          }}
          onSubmit={debounce(onSubmit)}
        >
          {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
            <>
              <Box className={css(Style.mainBoxStyle)}>
                <Grid item md={8} sm={12}>
                  <div
                    style={{ padding: "0px 0px 0px 10px", color: "#8C8C8C" }}
                  >
                    <Typography fontWeight="500" fontSize="20px">
                      Pending Transfer
                    </Typography>
                  </div>
                  <div style={{ padding: "30px 0px 0px 10px" }}>
                    <NewOrganization
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      showBlock
                    />
                  </div>
                  <Divider
                    sx={{
                      display: "flex",
                      width: "100%",
                      paddingTop: "20px",
                    }}
                  />
                  <div style={{ padding: "20px 0px 0px 10px" }}>
                    <AcceptForm
                      values={values}
                      handleChange={handleChange}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      selectedRow={selectedRow}
                    />
                  </div>
                </Grid>
                <Box
                  style={{
                    padding: isMobile ? "0" : "50px 0px 0px 30px",
                    height: isMobile ? "0" : "550px",
                  }}
                >
                  <Divider orientation="vertical" variant="middle" />
                </Box>
                <Grid item md={6} sm={12}>
                  <Typography variant="small" weight={500} color="#183053">
                    {[
                      selectedRow?.initiatorMember?.areaName,
                      selectedRow?.initiatorMember?.clusterName,
                      selectedRow?.initiatorMember?.zoneName,
                      selectedRow?.initiatorMember?.regionName,
                      selectedRow?.initiatorMember?.chapterName,
                      selectedRow?.initiatorMember?.districtName,
                    ]
                      .filter(Boolean)
                      .join("/ ")}
                  </Typography>
                  <div
                    style={{
                      marginLeft: isMobile ? "0" : "30px",
                      padding: "35px 10px 0px 0px",
                    }}
                  >
                    <div style={{ paddingTop: "30px" }}>
                      <InputField
                        name="remark"
                        required
                        type="text"
                        key="remark"
                        variant="outlined"
                        label="Enter your remark here..."
                        style={{
                          ...Styles.inputStyle,
                          minWidth: isMobile ? "240px" : "460px",
                        }}
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        InputProps={{
                          sx: { minHeight: "91px", maxWidth: "400px" },
                        }}
                      />
                    </div>
                    <RemarksList remarks={remarks} />
                  </div>
                </Grid>
              </Box>
              <>
                {/* <Divider
                  sx={{
                    display: "flex",
                    width: "100%",
                    paddingTop: "1%",
                  }}
                /> */}
                <Box
                  style={{ display: "flex", gap: 10, marginLeft: "10px" }}
                  className={css(Style.buttonDivStyle)}
                >
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    style={CommonStyles.buttonStyle}
                    label="Submit"
                    type="submit"
                  />

                  <Button
                    variant="outlined"
                    onClick={onClose}
                    style={CommonStyles.buttonStyle}
                    label="Cancel"
                  />
                </Box>
              </>
            </>
          )}
        </Formik>
      </Grid>
    </Modal>
  );
}

export default AcceptModal;
